<template>
  <div class="ws-file-uploader">
    TEST
    <div class="ws-file-uploader-list" v-if="files">
      <transition-group name="list-complete" tag="div" :class="{'is-loading': isRemovePending}">
        <div class="ws-file-uploader-label text-muted" v-for="(file, index) in files" :key="file.guid">
          <span class="ws-file-uploader-file-icon ws-icon-document"></span>
          <div class="ws-file-uploader-file-name">{{ file.file_name }}  ({{ prettyBytes(file.file_size) }})</div>
          <div class="ws-file-uploader-file-control">
            <button type="button" class="delete" @click="removeFile(file.guid, index)" aria-label="close"></button>
          </div>
        </div>
      </transition-group>
    </div>
    <div class="ws-file-uploader-wrapper" :class="{'is-loading': isUploadPending}" v-if="!hideUploadButton">
      <ws-field class="ws-file-uploader" v-if="isShowButton">
        <b-upload @input="uploadFiles" :multiple="isMultiple" drag-drop v-model="formFilesList">
          <a class="button is-danger ws-file-uploader-button">
            <span class="is-size-4">{{ submitTitle }}</span>
            <ws-spinner v-if="isUploadPending" />
          </a>
        </b-upload>
      </ws-field>
    </div>
  </div>
</template>

<script>
import prettyBytes from '@/filters/prettyBytes'
export default {
  name: 'WsFileUpload',
  props: {
    isMultiple: {
      type: Boolean,
      default: true
    },
    buttonTitle: {
      type: String,
      default: 'Загрузить документ'
    },
    itemGuid: {
      type: String,
      default: null
    },
    userGuid: {
      type: String,
      default: null
    },
    category: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      isUploadPending: false,
      isRemovePending: false,
      files: [],
      formFilesList: null
    }
  },
  computed: {
    isShowButton () {
      return this.itemGuid
    },
    submitTitle () {
      return this.isUploadPending ? this.$t(`Загружаем. Секунду...`) : this.buttonTitle
    },
    hideUploadButton () {
      return !this.isMultiple && this.files && this.files.length > 0
    }
  },
  methods: {
    prettyBytes,
    async removeFile (guid, index) {
      this.isRemovePending = true
    },
    async uploadFiles (files) {
      this.isUploadPending = true

      const formData = new FormData()

      if (this.isMultiple) {
        files.forEach(file => {
          formData.append('file', file, file.filename)
        })
      } else {
        formData.append('file', files, files.filename)
      }

      try {
        const url = `${__config.api_url}/api/dpws/general-files/add/category/${this.category}/${this.itemGuid}`
        await fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'multipart/form-data' },
          body: formData
        })
        this.$buefy.toast.open({
          message: this.$t(`Файл(-ы) успешно загружены`),
          type: 'is-success'
        })
        this.getFiles()
      } catch (e) {
        console.log(e)
      }

      this._clearFormFilesList()
      this.isUploadPending = false
    },
    async getFiles () {
      this.isUploadPending = true
      const url = `${__config.api_url}/api/dpws/general-files/category/${this.category}/${this.itemGuid}`
      const response = await fetch(url)
      const { data } = await response.json()
      this.files = data
      this.isUploadPending = false
      this.$emit('input', this.files)
    },
    _clearFormFilesList () {
      this.formFilesList = []
    }
  },
  mounted () {
    if (this.itemGuid) {
      this.getFiles()
    }
  }
}
</script>

<style scoped>
  .list-complete-item {
    transition: all 1s;
  }
  .list-complete-enter, .list-complete-leave-to {
    opacity: 0;
  }
  .list-complete-item-enter {
    transform: translateY(0);
  }

  .list-complete-item-leave-to {
    transform: translateY(-100%);
  }
  .list-complete-leave-active {
    position: absolute;
  }
</style>
